import React from 'react';
import {connect} from "react-redux";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class PlanOwnershipPopupComponent extends CommonTab {
    state = {
        planOwnership: this.props.planOwnership,
        errors: [],
        validateFields: [
            'ownershiptypename',
            'ownershiptypenameeng',
            // 'description'
        ]
    };

    changeState(name, e) {
        let temp = this.state.planOwnership;
        temp[name] = e.value;
        this.setState({planOwnership: temp});
    }

    render() {
        let {planOwnership, errors, validateFields} = this.state;
        return (
            <Popup openClose={this.props.openClose}>
                <div className={'popup-content-types'}>
                    <form onSubmit={event => {
                        event.preventDefault();
                        if (!('description' in planOwnership)) {
                            planOwnership['description'] = ''
                        }
                        this.formValidation(planOwnership, validateFields);
                    }}>
                        <h2>{this.props.button} Ownership Type</h2>
                        <table className={'table table-striped'} align={'right'}>
                            <tbody>
                            <tr>
                                <td>Plan Ownership Name :</td>
                                <td className={errors.indexOf('ownershiptypename') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={planOwnership.ownershiptypename}
                                        onChange={(e) => {
                                            this.changeState('ownershiptypename', e.target);
                                        }}
                                    />
                                    {errors.indexOf('ownershiptypename') !== -1 ? <span className="errorText">Please set Ownership Name</span> : '' }
                                </td>
                            </tr>
                            <tr>
                                <td>Plan Ownership Name Eng :</td>
                                <td className={errors.indexOf('ownershiptypenameeng') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={planOwnership.ownershiptypenameeng}
                                        onChange={(e) => {
                                            this.changeState('ownershiptypenameeng', e.target);
                                        }}
                                    />
                                    {errors.indexOf('ownershiptypenameeng') !== -1 ? <span className="errorText">Please set Ownership Name</span> : '' }
                                </td>
                            </tr>
                            <tr>
                                <td>Plan Ownership Description :</td>
                                <td className={errors.indexOf('description') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={planOwnership.description}
                                        onChange={(e) => {
                                            this.changeState('description', e.target);
                                        }}
                                    />
                                    {errors.indexOf('description') !== -1 ? <span className="errorText">Please set Description</span> : '' }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                    </form>
                </div>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let content = {};
    state.ownerShipType.map((item) => {
        if (item.ownershiptypeid == ownProps.id) {
            content = item;
        }
    });
    return {
        planOwnership: Object.assign({}, content)
    }
};

const PlanOwnershipPopup = connect(mapStateToProps)(PlanOwnershipPopupComponent);
export default PlanOwnershipPopup;